import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { Select } from 'ksnm-common-ui/lib/Select';
import { uniqBy } from 'lodash-es';

import { logsStore } from '@stores/logsStore';

import styles from './EtlTypeFilter.module.scss';

interface IEtlTypeFilter {
  setSelectedProcess: React.Dispatch<React.SetStateAction<string[]>>;
}

export const EtlTypeFilter = observer(({ setSelectedProcess }: IEtlTypeFilter) => {
  const { etlTypes, etlTypeFilter, setEtlTypeFilter, setExpandedKeys } = logsStore;

  const items = useMemo(
    () =>
      uniqBy(
        etlTypes.filter((type) => !!type.etlTypeFilter),
        'etlTypeFilter',
      ).map((type) => ({
        name: type.etlTypeFilter,
        id: type.etlTypeFilter,
      })),
    [etlTypes],
  );

  const onChange = (v) => {
    setSelectedProcess([]);
    setExpandedKeys([]);
    setEtlTypeFilter(v);
  };

  if (etlTypes.length === 0 || items.length === 0) return null;

  return (
    <Select
      items={items}
      size="small"
      className={styles.select}
      value={etlTypeFilter}
      onChange={onChange}
      placeholder="Фильтр"
    />
  );
});
